import { Skeleton, TableCell, TableRow as MuiTableRow } from '@mui/material';

interface Props {
  nrOfColumns: number;
}

export function TableBodySkeleton({ nrOfColumns }: Props) {
  return (
    <>
      <MuiTableRow>
        <TableCell colSpan={nrOfColumns}>
          <Skeleton height="2rem" width="100%" />
        </TableCell>
      </MuiTableRow>
      <MuiTableRow>
        <TableCell colSpan={nrOfColumns}>
          <Skeleton height="2rem" width="100%" />
        </TableCell>
      </MuiTableRow>
      <MuiTableRow>
        <TableCell colSpan={nrOfColumns}>
          <Skeleton height="2rem" width="100%" />
        </TableCell>
      </MuiTableRow>
    </>
  );
}
